module.exports = __webpack_public_path__ + "videos/home.f4e2c363.mov";